import { gql } from 'graphql-request'

export const M_PAUSE_SUBSCRIPTION = gql`
  mutation PauseSubscription($months: Int!) {
    pauseSubscription(months: $months) {
      ... on PauseResult {
        success
        resumesAt
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`
